function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "pfx65950__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 0 0.890196 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  d: "M0 0v21.574c16.399 0 29.695 3.485 29.695 7.785v43.97C29.695 77.63 16.4 83.616 0 83.616L.058 91H73V0",
  id: "pfx65950__b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.265 60.2c0 4.308 13.413 7.8 29.96 7.8 16.546 0 29.96-3.492 29.96-7.8L68 8.413 0 7",
  id: "pfx65950__d"
}), /*#__PURE__*/React.createElement("filter", {
  id: "pfx65950__f"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "pfx65950__g",
  d: "M0 0L59.6026548 0 59.6026548 30 0 30z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(156 29)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(133.37 34.868)",
  filter: "url(#pfx65950__a)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E84A32",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.527 4.857)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 5.08 4.235)",
  d: "M2.888 8.864L7.272 -0.394"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 8.187 13.798)",
  d: "M9.914 18.619L6.459 8.977"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 16.403 19.587)",
  d: "M21.112 21.613L11.694 17.561"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 27.242 13.95)",
  d: "M31.353 10.891L23.13 17.01"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 29.865 2.526)",
  d: "M30.517 -2.553L29.212 7.604"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.974 16.332L4 18.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.974 19.332L0.375 19.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.668 23.801L17.502 27.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.668 0.801L30.502 4.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.075 21L33.388 25.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.075 29L35.375 29.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.075 0L21.388 4.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.341 12.426L40.424 13.399"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.341 14.426L46.375 14.632"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E84A32",
  cx: 26.875,
  cy: 10.132,
  r: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M66 60c0 4.419-13.655 8-30.5 8S5 64.419 5 60c0-4.419 13.655-8 30.5-8S66 55.581 66 60",
  fill: "#544D44"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 72c6-41-26-55-25.754-77 .245-22 33-24 45-12s19 18 38 41 51-6 35-21-51 9-78 4-9-39 16-25 50 66 24 100-108 12-116-27 24-53 54-44 64 76 129 76 76-40 61-61-61-15-59 12",
  stroke: "#EBEDE3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 60)",
  fill: "#CAC5B8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 44.542V12c0 4.372 13.655 7.915 30.5 7.915S61 16.372 61 12v32.542C61 48.914 47.345 55 30.5 55S0 48.914 0 44.542"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8V0c0 4.419 13.655 8 30.5 8S61 4.419 61 0v8c0 4.419-13.655 8-30.5 8S0 12.419 0 8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.3 30.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx65950__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx65950__b"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.914 23.849c3.364-2.637 14.24 5.832 24.296 18.916 10.056 13.083 15.481 25.826 12.117 28.462-3.363 2.637-14.24-5.832-24.297-18.916C13.974 39.228 8.55 26.485 11.914 23.849",
  fill: "#544D44",
  mask: "url(#pfx65950__c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.417 66.454l-6.09 4.773c3.365-2.637-2.06-15.38-12.116-28.462-10.056-13.083-20.934-21.553-24.297-18.917l6.09-4.772c3.363-2.637 14.241 5.832 24.297 18.916 10.056 13.082 15.48 25.825 12.116 28.462",
  fill: "#CAC5B8",
  mask: "url(#pfx65950__c)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "pfx65950__e",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx65950__d"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#pfx65950__e)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.947 40)",
  filter: "url(#pfx65950__f)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx65950__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx65950__g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M59.603 0H46.19c0 9.598-6.19 17.252-16.187 17.252C19.867 17.252 13.41 9.598 13.41 0H0c0 16.534 13.466 30 29.869 30C46.4 30 59.603 16.667 59.603 0",
  fill: "#EE4926",
  mask: "url(#pfx65950__h)"
}))));

function SvgIntro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 146,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro);
export default __webpack_public_path__ + "static/media/intro.893d00fd.svg";
export { ForwardRef as ReactComponent };